/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Badge }  from '@material-ui/core';
import { Star } from './Star';

const useStyles = makeStyles({
    matchBar: {
        textAlign: "center",
        margin: "1em"
    }
});

export interface MatchBarProps {
    maxWins: number,
    wins: number
}

export const MatchBar = (props: MatchBarProps) => {
    const classes = useStyles();
    return (
        <Box className={classes.matchBar}>
            {fillWinStars(props.wins)}
            {fillRemainingStars(props.maxWins - props.wins)}
        </Box>
    );
}

const fillWinStars = (wins: number): JSX.Element[] => {
    const star = (
        <Badge key={"win-" + wins}>
            <Star win={true} />
        </Badge>
    );

    return wins > 0 ? [star].concat(fillWinStars(wins - 1)) : [(<React.Fragment key={"win-end"}></React.Fragment>)];
}

const fillRemainingStars = (matchesToGo: number): JSX.Element[] => {
    const hollowStar = (
        <Badge key={"to-go-" + matchesToGo}>
            <Star win={false} />
        </Badge>
    );

    return matchesToGo > 0 ? [hollowStar].concat(fillRemainingStars(matchesToGo - 1)) : [<React.Fragment key="to-go-end"></React.Fragment>]
}

